export const toggleMenu = ({ state }, showMenu) => {
	state.showMenu = showMenu
}
